import { HStack } from "@chakra-ui/react";

export const TableBoxBadges: React.FC<React.PropsWithChildren> = ({
  children,
}) => <HStack gap={1}>{children}</HStack>;
